import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

// Eagerly load only the public landing page so the first paint is instant.
import HomePage from '../views/Storefront/HomePage.vue'

// Webpack chunk-name comments group related lazy chunks for friendlier network tabs.
const lazy = (loader) => loader

const CategoryView      = () => import(/* webpackChunkName: "category" */ '../views/Category/CategoryView.vue')
const AddCategory       = () => import(/* webpackChunkName: "category" */ '../views/Category/AddCategory.vue')
const EditCategory      = () => import(/* webpackChunkName: "category" */ '../views/Category/EditCategory.vue')
const ProduitCategory   = () => import(/* webpackChunkName: "storefront" */ '../views/Storefront/CategoryPage.vue')

const ProductDetails    = () => import(/* webpackChunkName: "product" */ '../views/Product/ProductDetails.vue')
const Liste             = () => import(/* webpackChunkName: "product" */ '../views/Product/Liste.vue')

const RegisterV         = () => import(/* webpackChunkName: "vendeur" */ '../views/Vendeur/RegisterV.vue')
const LoginViewV        = () => import(/* webpackChunkName: "vendeur" */ '../views/Vendeur/LoginViewV.vue')

const VendorShell           = () => import(/* webpackChunkName: "vendor-redesign" */ '@/views/Vendeur/VendorShell.vue')
const VendorDashboardHome   = () => import(/* webpackChunkName: "vendor-redesign" */ '@/views/Vendeur/sections/DashboardHome.vue')
const VendorProductsSection = () => import(/* webpackChunkName: "vendor-redesign" */ '@/views/Vendeur/sections/ProductsSection.vue')
const VendorProductForm     = () => import(/* webpackChunkName: "vendor-redesign" */ '@/views/Vendeur/sections/ProductForm.vue')
const VendorSalesSection    = () => import(/* webpackChunkName: "vendor-redesign" */ '@/views/Vendeur/sections/SalesSection.vue')
const VendorStockSection    = () => import(/* webpackChunkName: "vendor-redesign" */ '@/views/Vendeur/sections/StockSection.vue')
const VendorPromotionsSection = () => import(/* webpackChunkName: "vendor-redesign" */ '@/views/Vendeur/sections/PromotionsSection.vue')
const VendorInvoicesSection = () => import(/* webpackChunkName: "vendor-redesign" */ '@/views/Vendeur/sections/InvoicesSection.vue')
const VendorProfileSection  = () => import(/* webpackChunkName: "vendor-redesign" */ '@/views/Vendeur/sections/ProfileSection.vue')
const PatnersPlatform   = () => import(/* webpackChunkName: "vendeur" */ '../views/Vendeur/PatnersPlatform.vue')
const ResetPassword     = () => import(/* webpackChunkName: "vendeur" */ '../views/Vendeur/ResetPassword.vue')
const RequestPassword   = () => import(/* webpackChunkName: "vendeur" */ '../views/Vendeur/RequestPassword.vue')

const LoginLivreurs     = () => import(/* webpackChunkName: "livreur" */ '@/views/livreurs/loginLivrure.vue')
const LivreurShell        = () => import(/* webpackChunkName: "livreur-redesign" */ '@/views/livreurs/LivreurShell.vue')
const LivreurDashboardHome = () => import(/* webpackChunkName: "livreur-redesign" */ '@/views/livreurs/sections/DashboardHome.vue')
const LivreurOrdersSection = () => import(/* webpackChunkName: "livreur-redesign" */ '@/views/livreurs/sections/OrdersSection.vue')
const LivreurHistorySection = () => import(/* webpackChunkName: "livreur-redesign" */ '@/views/livreurs/sections/HistorySection.vue')
const LivreurReturnsSection = () => import(/* webpackChunkName: "livreur-redesign" */ '@/views/livreurs/sections/ReturnsSection.vue')
const LivreurProfileSection = () => import(/* webpackChunkName: "livreur-redesign" */ '@/views/livreurs/sections/ProfileSection.vue')
const DetaileLivraison  = () => import(/* webpackChunkName: "livreur" */ '@/views/livreurs/detaileLivrison.vue')

const RegisterC         = () => import(/* webpackChunkName: "client" */ '@/views/Client/RegisterC.vue')
const LogineC           = () => import(/* webpackChunkName: "client" */ '@/views/Client/logineC.vue')
const EditProfileC      = () => import(/* webpackChunkName: "client" */ '@/views/Client/editC.vue')
// Social auth (Google) — receives the redirect from
// /api/auth/{provider}/callback, persists the token, and routes the
// user either to /auth/complete-profile (new signup) or to /.
const AuthCallback      = () => import(/* webpackChunkName: "client" */ '@/views/Client/AuthCallback.vue')
const CompleteProfile   = () => import(/* webpackChunkName: "client" */ '@/views/Client/CompleteProfile.vue')

// Account zone (C2 redesign) — replaces /profileC, /command, /factureC.
const AccountShell           = () => import(/* webpackChunkName: "account" */ '@/views/Client/account/AccountShell.vue')
const AccountDashboardHome   = () => import(/* webpackChunkName: "account" */ '@/views/Client/account/sections/DashboardHome.vue')
const AccountProfile         = () => import(/* webpackChunkName: "account" */ '@/views/Client/account/sections/ProfileSection.vue')
const AccountAddresses       = () => import(/* webpackChunkName: "account" */ '@/views/Client/account/sections/AddressesSection.vue')
const AccountOrders          = () => import(/* webpackChunkName: "account" */ '@/views/Client/account/sections/OrdersSection.vue')
const AccountOrderDetail     = () => import(/* webpackChunkName: "account" */ '@/views/Client/account/sections/OrderDetail.vue')
const AccountInvoices        = () => import(/* webpackChunkName: "account" */ '@/views/Client/account/sections/InvoicesSection.vue')
const AccountInvoiceDetail   = () => import(/* webpackChunkName: "account" */ '@/views/Client/account/sections/InvoiceDetail.vue')
const AccountReturns         = () => import(/* webpackChunkName: "account" */ '@/views/Client/account/sections/ReturnsSection.vue')
const AccountLists           = () => import(/* webpackChunkName: "account" */ '@/views/Client/account/sections/ListsSection.vue')
const ContacterClient   = () => import(/* webpackChunkName: "client" */ '@/views/Client/cantact.vue')
const resetPasswordC    = () => import(/* webpackChunkName: "client" */ '../views/Client/resetPasswordC.vue')
const requestPasswordC  = () => import(/* webpackChunkName: "client" */ '../views/Client/requestPasswordC.vue')

// Checkout v2 (C4) — replaces /panierPage and /buy.
const CartPage          = () => import(/* webpackChunkName: "checkout" */ '@/views/Checkout/CartPage.vue')
const CheckoutPage      = () => import(/* webpackChunkName: "checkout" */ '@/views/Checkout/CheckoutPage.vue')
const OrderSuccess      = () => import(/* webpackChunkName: "checkout" */ '@/views/Checkout/OrderSuccess.vue')
const OrderDetails      = () => import(/* webpackChunkName: "checkout" */ '@/views/OrderDetails.vue')
const listeDialog       = () => import(/* webpackChunkName: "checkout" */ '@/components/products/listeDialog.vue')

const LoginViewAdmin    = () => import(/* webpackChunkName: "admin" */ '@/views/Admin/loginAdmin.vue')
const AdminShell           = () => import(/* webpackChunkName: "admin-redesign" */ '@/views/Admin/AdminShell.vue')
const AdminDashboardHome   = () => import(/* webpackChunkName: "admin-redesign" */ '@/views/Admin/sections/DashboardHome.vue')
const AdminOrdersSection   = () => import(/* webpackChunkName: "admin-redesign" */ '@/views/Admin/sections/OrdersSection.vue')
const AdminVendorsSection  = () => import(/* webpackChunkName: "admin-redesign" */ '@/views/Admin/sections/VendorsSection.vue')
const AdminCommissionRulesSection = () => import(/* webpackChunkName: "admin-redesign" */ '@/views/Admin/sections/CommissionRulesSection.vue')
const AdminInvoicesSection        = () => import(/* webpackChunkName: "admin-redesign" */ '@/views/Admin/sections/InvoicesSection.vue')
const AdminClientsSection  = () => import(/* webpackChunkName: "admin-redesign" */ '@/views/Admin/sections/ClientsSection.vue')
const AdminLivreursSection = () => import(/* webpackChunkName: "admin-redesign" */ '@/views/Admin/sections/LivreursSection.vue')
const AdminReturnsSection  = () => import(/* webpackChunkName: "admin-redesign" */ '@/views/Admin/sections/ReturnsSection.vue')
const AdminHomeImagesSection = () => import(/* webpackChunkName: "admin-redesign" */ '@/views/Admin/sections/HomeImagesSection.vue')
const AdminSalesSection    = () => import(/* webpackChunkName: "admin-redesign" */ '@/views/Admin/sections/SalesSection.vue')
const AdminCategoriesSection = () => import(/* webpackChunkName: "admin-redesign" */ '@/views/Admin/sections/CategoriesSection.vue')
const AdminLivraisonsSection = () => import(/* webpackChunkName: "admin-redesign" */ '@/views/Admin/sections/LivraisonsSection.vue')
const AdminRevenueSection    = () => import(/* webpackChunkName: "admin-redesign" */ '@/views/Admin/sections/RevenueSection.vue')
const AdminReviewsModerationSection = () => import(/* webpackChunkName: "admin-redesign" */ '@/views/Admin/sections/ReviewsModerationSection.vue')
const SuperAdminAdminsSection      = () => import(/* webpackChunkName: "superadmin" */ '@/views/Admin/sections/AdminsSection.vue')

const LoginViewAdminSuper = () => import(/* webpackChunkName: "superadmin" */ '@/views/superAdmin/logineS.vue')

const ReviewPage        = () => import(/* webpackChunkName: "review" */ '@/views/ReviewPage.vue')
const NotFound          = () => import(/* webpackChunkName: "misc" */ '../views/NotFound.vue')

// retain unused export for compatibility
void lazy

const routes = [
  { path: '/', name: 'HomePage', component: HomePage },

  { path: '/review/:productId', name: 'ReviewPage', component: ReviewPage, props: true },
  // Legacy URL — return management is now consolidated under /account/returns.
  { path: '/retour', name: 'RetourView', redirect: { path: '/account/returns', query: { tab: 'request' } } },
  { path: '/contacter', name: 'ContacterClient', component: ContacterClient },
  // Legacy livreur change-password URL — redirected to the new profile section.
  { path: '/changepassword/:id', name: 'ChangePassword', redirect: '/livreur/profile' },
  {
    path: '/detaileLivraison/:id',
    name: 'DetaileLivraison',
    component: DetaileLivraison,
    props: true,
    meta: {
      requiresAuth: true,
      isLivreur: true,
      hideFooter: true, // hides the storefront FootBar + BottomNav for livreur pages
      loginRoute: 'LoginLivreurs',
    },
  },
  { path: '/editProfileC', name: 'EditProfileC', component: EditProfileC, meta: { hideFooter: true } },
  // Legacy URL — kept as a redirect so old bookmarks still work.
  { path: '/adminDashboard', redirect: '/admin/dashboard' },
  // ── Admin (redesign) ────────────────────────────────────────────────────
  {
    path: '/admin',
    component: AdminShell,
    props: { role: 'admin' },
    meta: { requiresAuth: true, isAdmin: true, isSuperAdmin: true, hideFooter: true, loginRoute: 'LoginViewAdmin' },
    children: [
      { path: '', redirect: { name: 'AdminDashboardHome' } },
      { path: 'dashboard', name: 'AdminDashboardHome', component: AdminDashboardHome,    props: { role: 'admin' } },
      { path: 'orders',    name: 'AdminOrders',        component: AdminOrdersSection },
      { path: 'vendors',   name: 'AdminVendors',       component: AdminVendorsSection,   props: { role: 'admin' } },
      { path: 'clients',   name: 'AdminClients',       component: AdminClientsSection },
      { path: 'livreurs',   name: 'AdminLivreurs',    component: AdminLivreursSection },
      { path: 'categories', name: 'AdminCategories',  component: AdminCategoriesSection },
      { path: 'livraisons', name: 'AdminLivraisons',  component: AdminLivraisonsSection },
      { path: 'returns',    name: 'AdminReturns',     component: AdminReturnsSection },
      { path: 'home',       name: 'AdminHomeImages',  component: AdminHomeImagesSection },
      { path: 'sales',      name: 'AdminSales',       component: AdminSalesSection },
      { path: 'commissions', name: 'AdminCommissions', component: AdminCommissionRulesSection },
      { path: 'invoices',    name: 'AdminInvoices',    component: AdminInvoicesSection, props: { role: 'admin' } },
      { path: 'reviews',     name: 'AdminReviews',     component: AdminReviewsModerationSection },
    ],
  },
  // ── Super Admin (redesign) ──────────────────────────────────────────────
  {
    path: '/super-admin',
    component: AdminShell,
    props: { role: 'super-admin' },
    meta: { requiresAuth: true, isSuperAdmin: true, hideFooter: true, loginRoute: 'LoginViewAdminSuper' },
    children: [
      { path: '', redirect: { name: 'SuperAdminDashboardHome' } },
      { path: 'dashboard',   name: 'SuperAdminDashboardHome', component: AdminDashboardHome,     props: { role: 'super-admin' } },
      { path: 'orders',      name: 'SuperAdminOrders',        component: AdminOrdersSection },
      { path: 'vendors',     name: 'SuperAdminVendors',       component: AdminVendorsSection,    props: { role: 'super-admin' } },
      { path: 'clients',     name: 'SuperAdminClients',       component: AdminClientsSection },
      { path: 'livreurs',    name: 'SuperAdminLivreurs',     component: AdminLivreursSection },
      { path: 'categories',  name: 'SuperAdminCategories',   component: AdminCategoriesSection },
      { path: 'livraisons',  name: 'SuperAdminLivraisons',   component: AdminLivraisonsSection },
      { path: 'returns',     name: 'SuperAdminReturns',      component: AdminReturnsSection },
      { path: 'home',        name: 'SuperAdminHomeImages',   component: AdminHomeImagesSection },
      { path: 'sales',       name: 'SuperAdminSales',        component: AdminSalesSection },
      { path: 'revenue',     name: 'SuperAdminRevenue',      component: AdminRevenueSection },
      { path: 'commissions', name: 'SuperAdminCommissions',  component: AdminCommissionRulesSection },
      { path: 'invoices',    name: 'SuperAdminInvoices',     component: AdminInvoicesSection, props: { role: 'super-admin' } },
      { path: 'reviews',     name: 'SuperAdminReviews',      component: AdminReviewsModerationSection },
      { path: 'admins',      name: 'SuperAdminAdmins',       component: SuperAdminAdminsSection },
    ],
  },
  // Legacy URL — kept as a redirect so old bookmarks still work.
  { path: '/superAdmin', redirect: '/super-admin/dashboard' },
  {
    path: '/LoginViewAdminSuper',
    name: 'LoginViewAdminSuper',
    component: LoginViewAdminSuper,
    props: route => ({ nextUrl: route.query.nextUrl }),
    meta: { hideFooter: true }
  },
  // Legacy livreur dashboard URL — redirected to the new shell.
  { path: '/dachboardLivreur', name: 'DachboardLivreur', redirect: '/livreur/dashboard' },
  // ── Livreur (redesign) ──────────────────────────────────────────────────
  {
    path: '/livreur',
    component: LivreurShell,
    meta: { requiresAuth: true, isLivreur: true, hideFooter: true, loginRoute: 'LoginLivreurs' },
    children: [
      { path: '',           redirect: { name: 'LivreurDashboardHome' } },
      { path: 'dashboard',  name: 'LivreurDashboardHome', component: LivreurDashboardHome },
      { path: 'orders',     name: 'LivreurOrders',        component: LivreurOrdersSection },
      { path: 'history',    name: 'LivreurHistory',       component: LivreurHistorySection },
      { path: 'returns',    name: 'LivreurReturns',       component: LivreurReturnsSection },
      { path: 'profile',    name: 'LivreurProfile',       component: LivreurProfileSection },
    ],
  },
  {
    path: '/loginViewAdmin',
    name: 'LoginViewAdmin',
    component: LoginViewAdmin,
    props: route => ({ nextUrl: route.query.nextUrl }),
    meta: { hideFooter: true }
  },
  {
    path: '/loginLivreurs',
    name: 'LoginLivreurs',
    component: LoginLivreurs,
    props: route => ({ nextUrl: route.query.nextUrl }),
    meta: { hideFooter: true }
  },
  // Legacy URLs — redirected to the new /account/* routes (C2 redesign).
  { path: '/command',  name: 'CommandesC',        redirect: '/account/orders' },
  { path: '/factureC', name: 'ClientFacturation', redirect: '/account/invoices' },
  {
    path: '/order/:id',
    name: 'OrderDetails',
    component: OrderDetails,
    props: true,
    meta: { requiresAuth: true, isAdmin: true, isSuperAdmin: true, hideFooter: true, loginRoute: '/:catchAll(.*)' }
  },
  { path: '/profileC', name: 'ProfileC', redirect: '/account/dashboard' },
  // ── Account zone (C2 redesign) ─────────────────────────────────────────
  {
    path: '/account',
    component: AccountShell,
    meta: { requiresAuth: true, isClient: true, hideFooter: true, loginRoute: 'LogineC' },
    children: [
      { path: '',           redirect: { name: 'AccountDashboardHome' } },
      { path: 'dashboard',  name: 'AccountDashboardHome', component: AccountDashboardHome },
      { path: 'profile',    name: 'AccountProfile',       component: AccountProfile },
      { path: 'addresses',  name: 'AccountAddresses',     component: AccountAddresses },
      { path: 'orders',     name: 'AccountOrders',        component: AccountOrders },
      { path: 'orders/:id', name: 'AccountOrderDetail',   component: AccountOrderDetail },
      { path: 'invoices',     name: 'AccountInvoices',      component: AccountInvoices },
      { path: 'invoices/:id', name: 'AccountInvoiceDetail', component: AccountInvoiceDetail },
      { path: 'returns',    name: 'AccountReturns',       component: AccountReturns },
      { path: 'lists',      name: 'AccountLists',         component: AccountLists },
    ],
  },
  // New checkout (C4)
  { path: '/cart',                  name: 'CartPage',     component: CartPage,     meta: { requiresAuth: true, isClient: true, loginRoute: 'LogineC' } },
  { path: '/checkout',              name: 'CheckoutPage', component: CheckoutPage, meta: { requiresAuth: true, isClient: true, loginRoute: 'LogineC' } },
  { path: '/order-success/:id',     name: 'OrderSuccess', component: OrderSuccess, meta: { requiresAuth: true, isClient: true, loginRoute: 'LogineC' } },
  // Legacy URLs — redirected to the new checkout flow.
  { path: '/panierPage', name: 'PanierPage',    redirect: '/cart' },
  { path: '/buy',        name: 'BuyComponent',  redirect: '/checkout' },
  { path: '/listeDialog', name: 'ListeDialog', component: listeDialog },
  // Legacy URL — kept as a redirect so existing in-app links land on the new vendor profile.
  { path: '/editProfileV/:vendeurId', name: 'EditProfileV', redirect: '/vendor/profile' },
  {
    path: '/addCategory',
    name: 'AddCategory',
    component: AddCategory,
    meta: { hideFooter: true, requiresAuth: true, isAdmin: true, isSuperAdmin: true, loginRoute: '/:catchAll(.*)' }
  },
  {
    path: '/category',
    name: 'CategoryView',
    component: CategoryView,
    meta: { hideFooter: true, quiresAuth: true, isAdmin: true, isSuperAdmin: true, loginRoute: '/:catchAll(.*)' }
  },
  {
    path: '/edit-category/:id',
    name: 'EditCategory',
    component: EditCategory,
    props: true,
    meta: { hideFooter: true, requiresAuth: true, isAdmin: true, isSuperAdmin: true, loginRoute: '/:catchAll(.*)' }
  },
  // Legacy standalone product create — redirected to the new in-shell route.
  { path: '/addProduct', redirect: '/vendor/products/new' },
  {
    path: '/logineC',
    name: 'LogineC',
    component: LogineC,
    props: route => ({ nextUrl: route.query.nextUrl }),
    meta: { hideFooter: true }
  },
  { path: '/patnersPlatform', name: 'PatnersPlatform', component: PatnersPlatform, meta: { hideFooter: true } },
  {
    path: '/produitCategory/:id/:name',
    name: 'ProduitCategory',
    component: ProduitCategory,
    props: true
  },
  { path: '/registerC', name: 'RegisterC', component: RegisterC, meta: { hideFooter: true } },
  { path: '/registerV', name: 'RegisterV', component: RegisterV, meta: { hideFooter: true } },
  // Social auth flow (Google). Both pages hide the global footer
  // so the experience matches login + register.
  { path: '/auth/callback',          name: 'AuthCallback',     component: AuthCallback,    meta: { hideFooter: true } },
  { path: '/auth/complete-profile',  name: 'CompleteProfile',  component: CompleteProfile, meta: { hideFooter: true } },
  {
    path: '/loginViewV',
    name: 'LoginViewV',
    component: LoginViewV,
    props: route => ({ nextUrl: route.query.nextUrl }),
    meta: { hideFooter: true }
  },
  // Legacy URL — kept as a redirect so existing bookmarks land on the new dashboard.
  { path: '/vendeurView', redirect: '/vendor/dashboard' },
  // ── Vendor (redesign) ───────────────────────────────────────────────────
  {
    path: '/vendor',
    component: VendorShell,
    meta: { requiresAuth: true, isVendeur: true, hideFooter: true, loginRoute: 'LoginViewV' },
    children: [
      { path: '',           redirect: { name: 'VendorDashboardHome' } },
      { path: 'dashboard',     name: 'VendorDashboardHome', component: VendorDashboardHome },
      { path: 'products',      name: 'VendorProducts',      component: VendorProductsSection },
      { path: 'products/new',  name: 'VendorProductCreate', component: VendorProductForm, props: { mode: 'create' } },
      { path: 'products/:id/edit', name: 'VendorProductEdit', component: VendorProductForm, props: { mode: 'edit' } },
      { path: 'promotions', name: 'VendorPromotions',    component: VendorPromotionsSection },
      { path: 'sales',      name: 'VendorSales',         component: VendorSalesSection },
      { path: 'stock',      name: 'VendorStock',         component: VendorStockSection },
      { path: 'invoices',   name: 'VendorInvoices',      component: VendorInvoicesSection },
      { path: 'profile',    name: 'VendorProfile',       component: VendorProfileSection },
    ],
  },
  { path: '/liste', name: 'Liste', component: Liste },
  // Legacy standalone product edit — redirected to the new in-shell route.
  { path: '/editProduct/:id', redirect: (to) => `/vendor/products/${to.params.id}/edit` },
  {
    path: '/productDetails/:id',
    name: 'ProductDetails',
    component: ProductDetails,
    props: true
  },
  { path: '/resetPasswordC', name: 'resetPasswordC', component: resetPasswordC, meta: { hideFooter: true } },
  { path: '/requestpasswordC', name: 'requestpasswordC', component: requestPasswordC, meta: { hideFooter: true } },
  { path: '/ResetPassword', name: 'ResetPassword', component: ResetPassword, meta: { hideFooter: true } },
  { path: '/requestpassword', name: 'requestpassword', component: RequestPassword, meta: { hideFooter: true } },
  // Legacy URL — promotion management is now /vendor/promotions for the whole catalogue.
  { path: '/add-reduction/:id', name: 'AddReduction', redirect: '/vendor/promotions' },
  { path: '/:catchAll(.*)', name: 'NotFound', component: NotFound },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    return { top: 0 }
  }
})

// Role-flag → token getter and matching login-screen route name.
// The guard always sends an unauthenticated visitor to the login screen
// that matches THE ROUTE THEY TRIED TO ACCESS — never to a different role's
// login just because some other token is sitting in localStorage.
// Order matters: when a route accepts MULTIPLE roles (e.g. order detail
// allows isAdmin + isSuperAdmin), the FIRST matching entry decides which
// login screen the unauthenticated visitor lands on. Admin-first means a
// shared admin/super page sends people to the regular admin login.
const ROLE_CONFIG = [
  {
    flag: 'isAdmin',
    tokenKey: 'adminToken',
    login: 'LoginViewAdmin',
  },
  {
    flag: 'isSuperAdmin',
    tokenKey: 'superAdminToken',
    login: 'LoginViewAdminSuper',
  },
  {
    flag: 'isVendeur',
    tokenKey: 'vendeurToken',
    login: 'LoginViewV',
  },
  {
    flag: 'isLivreur',
    tokenKey: 'livreurToken',
    login: 'LoginLivreurs',
  },
  {
    flag: 'isClient',
    tokenKey: 'clientToken',
    login: 'LogineC',
  },
];

function getToken(key) {
  return store.state[key] || localStorage.getItem(key) || null;
}

router.beforeEach((to, from, next) => {
  // Public route — let it through.
  if (!to.matched.some((record) => record.meta.requiresAuth)) {
    return next();
  }

  // Which role flags does this destination expect? A route may list more
  // than one (e.g. the order detail allows admin OR super admin).
  const requiredRoles = ROLE_CONFIG.filter((role) =>
    to.matched.some((record) => record.meta[role.flag])
  );

  // No role flag at all but requiresAuth=true → fall back to client.
  if (requiredRoles.length === 0) {
    if (getToken('clientToken')) return next();
    return next({ name: 'LogineC', query: { nextUrl: to.fullPath } });
  }

  // Pass if the user holds ANY of the accepted role tokens.
  const authorized = requiredRoles.some((role) => !!getToken(role.tokenKey));
  if (authorized) return next();

  // Not authorized: send them to the login that matches THIS route.
  // For multi-role pages we pick the first (most-privileged) one in the
  // list so e.g. an order-detail link lands on the admin login, not the
  // super-admin one.
  const targetLogin = requiredRoles[0].login;
  return next({ name: targetLogin, query: { nextUrl: to.fullPath } });
});

export default router
